<div class="add-traffic-source-wrapper">
  <div class="add-traffic-source-container">
    <div *ngIf="!isLoaded" class="loader">
      <app-loader></app-loader>
    </div>
    <div [ngClass]="{'d-none' : !isLoaded}">
      <div *ngIf="currentMode !== 'summary'; else summary">
        <div class="modal-header">
          <h6 class="font500 fontsize14">{{ 'view_translations.traffic_source' | translate }}</h6>
          <h2 class="fontsize30">{{ ( trafficSourceData ? 'view_translations.traffic_source_edit' : 'view_translations.add_traffic_source') | translate }}</h2>
          <p class="fontsize14 mt-2 mb-0 font500">{{ 'traffic_source_title_desc' | t }}</p>
        </div>
        <app-types-section *ngIf="!trafficSourceData" [modalConfig]="modalSettings" (selectedTrafficSourceType)="onSelectType($event)"></app-types-section>
        <hr class="separator" *ngIf="currentMode === 'details'" />
        <div *ngIf="currentMode === 'details'" class="choose-type">
          <app-details-section [fieldsSetting]="currentModalSetting" (setState)="onSetComponentState($event)"></app-details-section>
        </div>
      </div>
      <ng-template #summary>
        <app-add-traffic-source-summary [token]="verificationToken" [id]="trafficSourceId" [url]="url"></app-add-traffic-source-summary>
      </ng-template>
      <button class="btn close-button" (click)="closeModal()">
        <nb-icon icon="cross" pack="icomoon" class="cross-icon"></nb-icon>
      </button>
    </div>
  </div>
</div>
